module.exports = __webpack_public_path__ + "static/img/8.d4fbbbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/1/zh/8.png
// module id = iKfI
// module chunks = 0